import { FC, FunctionComponent, useMemo } from "react";
import styled from "styled-components";
import { Grid } from "../../../components/layout";
import { Loader } from "../../../components/loader";
import { Tabs } from "../../../components/tabs/tabs-page";
import { useFetchable } from "../../../store/common/fetchable";
import {
  Launch as LaunchData,
  LaunchesDTO,
} from "../../../store/launches/models/dto";
import { Launches } from "../../../store/launches/reducer";
import { device } from "../../../styles/media";
import { mapObject, reduceObject } from "../../../utils/utils";
import { NoLaunches } from "./empty";
import { Launch } from "./launch";

const Container = styled.div`
  font-size: 0.9em;
`;

const StyledGrid = styled(Grid)`
  gap: 1em;
  grid-template-columns: repeat(1, 1fr);

  @media ${device.tablet} {
    grid-template-columns: repeat(2, 1fr);
  }

  @media ${device.laptop} {
    grid-template-columns: repeat(3, 1fr);
    gap: 2em;
  }

  @media ${device.laptopL} {
    grid-template-columns: repeat(4, 1fr);
  }
`;

const PresentationalComponent: FunctionComponent<{
  list: LaunchesDTO.Responses.GetAll.T;
  ctaLink: string;
}> = ({ list, ctaLink }) => {
  const amount = useMemo(
    () => reduceObject(list.launches, (acc, curr) => acc + curr.length, 0),
    [list]
  );

  const tabs = useMemo(
    () =>
      mapObject<{
        key: string;
        value: LaunchData[] | undefined;
      }>(list.launches, (value, key) => ({
        key,
        value,
      }))
        .sort((a, b) => a.key.localeCompare(b.key))
        .map(({ value, key }) => ({
          title: key,
          content:
            value === undefined ? null : value.length < 1 ? (
              <NoLaunches />
            ) : (
              <StyledGrid>
                {value.map((x) => (
                  <Launch
                    {...x}
                    ctaLink={ctaLink}
                    key={x.id}
                    past={key === "PAST"}
                  />
                ))}
              </StyledGrid>
            ),
        })),
    [list]
  );

  if (amount === 0) return <NoLaunches />;

  return (
    <Container>
      <Tabs tabs={tabs}></Tabs>
    </Container>
  );
};

export const AllLaunches: FC<any> = (props) => {
  const data = useFetchable(Launches.all);

  return (
    <Loader data={[data]}>
      {([fulfilled]) => <PresentationalComponent {...props} list={fulfilled} />}
    </Loader>
  );
};
